import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

const IconNumber78Small = createReactComponent('outline', 'number-78-small', 'Number78Small', __iconNode);

export default IconNumber78Small;